import { always, equals, ifElse } from 'ramda';

import { WIDTH_TYPES } from '../../../utils/constants';
import { CHART_BACKGROUND_COLOR, PIE_CHART_PALETTE_LIGHT, TRANSPARENT } from '../../../utils/colors';

export const PIE_DEFAULT = {
  legendVisibility: true,
  titlesVisibility: true,
  // RADIUS
  pieOuterRadius: 0.8,
  pieInnerRadius: 0.43,
  labelOuterRadius: 1,
  pieOutlineWidth: 2,
  // COLORS
  background: CHART_BACKGROUND_COLOR,
  colors: PIE_CHART_PALETTE_LIGHT,
};

export const SIMPLE_PIE = {
  legendVisibility: false,
  titlesVisibility: false,
  // RADIUS
  pieOuterRadius: 0.8,
  pieInnerRadius: 0,
  labelOuterRadius: 1,
  pieOutlineWidth: 2,
  // COLORS
  background: TRANSPARENT,
  colors: PIE_CHART_PALETTE_LIGHT,
};

export const getPieConfig = (type) => {
  const condConfig = ifElse(
    equals(WIDTH_TYPES.SHORT),
    always({
      gridBackground: TRANSPARENT,
    }),
    always({})
  )(type);

  return {
    ...condConfig,
  };
};
